import React, { createContext, useState, useEffect, Fragment } from "react";
import { Box, Card, Stack } from "@mui/material";
import fetchData from "verticales/FetchData";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Typography from "@mui/material/Typography";
import MDTypography from "components/MDTypography";
import PanelInforArtefacto from "./PanelInfoArtefacto";
import HighlightOffIcon from "@mui/icons-material/HighlightOff";

const url = "https://5djo5qwa3l.execute-api.us-east-1.amazonaws.com/dimo-goyito/ec2/";
const viewData = (props) => {
  const [value, setValue] = React.useState(0);
  // console.log("ViewData props...", props);

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
  };

  const [dataRow, setDataRow] = useState(null);
  const [dataUsu, setDataUsu] = useState("");
  // console.log("Props.... desde View Data", props.row.original);
  const fetchDataFromApi = async () => {
    const params = {
      objeto: props.row.original,
      action: "get-by-instance",
    };
    try {
      const data = await fetchData(url, "ec2-disponibilidad", params);
      // console.log("Data...", data);
      const dataRow = data.instanciasCliente ?? [];
      const dataUser = data.usuariosCliente ? data.usuariosCliente.rows : [];
      setDataRow(dataRow);
      setDataUsu(dataUser);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    fetchDataFromApi();
  }, []);

  return (
    <Card
      sx={{
        marginTop: "20px",
        width: "100%",
        height: "96%",
        maxHeight: "100vh",
        overflowY: "auto",
        boxShadow: 24,
      }}
    >
      <Stack direction="row" alignItems="center" sx={{ p: 1 }}>
        <MDTypography
          variant="h4"
          fontWeight="medium"
          color="black"
          sx={{ flexGrow: 1, textAlign: "center" }}
        >
          Informe Disponibilidad {props.row.original.name_database}
        </MDTypography>
        <HighlightOffIcon
          onClick={props.handleCloseModal}
          sx={{
            cursor: "pointer",
            "&:hover": {
              transform: "scale(1.5)",
            },
          }}
          htmlColor="black"
        ></HighlightOffIcon>
      </Stack>
      <Box
        sx={{
          flexGrow: 1,
          // bgcolor: "background.paper",
          display: "flex",
          height: "calc(100% - 60px)",
        }}
      >
        {dataRow && (
          <Tabs
            orientation="vertical"
            value={value}
            onChange={handleChange}
            aria-label="Vertical tabs example"
            sx={{ borderRight: 1, borderColor: "divider", minWidth: 200 }}
          >
            {dataRow?.rows
              .sort((a, b) =>
                a.producto === "ERP" || a.producto === "ERP.NET" ? -1 : b.producto === "ERP" ? 1 : 0
              )
              .map((row, index) => (
                <Tab
                  label={
                    <CustomLabel
                      instance_id={row.instance_id}
                      producto={row.producto}
                      default_vcpus={row.default_vcpus}
                      memory_info={row.memory_info}
                    />
                  }
                  key={"tb-" + index}
                  {...a11yProps(index)}
                />
              ))}
          </Tabs>
        )}
        {dataRow?.rows.map((row, index) => (
          <TabPanel key={"tp-" + index} index={index} value={value}>
            <PanelInforArtefacto data={row} dataUsuarios={dataUsu} />
          </TabPanel>
        ))}
      </Box>
    </Card>
  );
};

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function TabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`vertical-tabpanel-${index}`}
      aria-labelledby={`vertical-tab-${index}`}
      {...other}
      style={{ width: "100%" }}
    >
      {value === index && (
        <Box sx={{ p: 1 }}>
          {/* <Typography>{children}hola como estas!!</Typography> */}
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

function a11yProps(index: number) {
  return {
    id: `vertical-tab-${index}`,
    "aria-controls": `vertical-tabpanel-${index}`,
  };
}

const CustomLabel = (props: any) => (
  <Box sx={{ flexGrow: 1 }}>
    <Typography variant="body" sx={{ fontWeight: "bold", fontSize: 14 }}>
      {props.instance_id}
    </Typography>
    <br />
    <Typography variant="body" sx={{ fontSize: 12 }}>
      {props.producto} cpu:{props.default_vcpus} ram:
      {props.memory_info / 1024} GB
    </Typography>
  </Box>
);

export default viewData;
